
import Vue from "vue";
import { Component } from "vue-property-decorator";
import code, { Code as CodeType } from "@/store/code";

@Component
export default class Code extends Vue {
  name = "Code";

  get codes(): CodeType[] {
    return this.$i18n.locale === "zh" ? code.zh : code.en;
  }

  get githubTitle(): string {
    return this.$i18n.locale === "zh" ? "iMoonLab 开源社区" : "iMoonLab on GitHub";
  }

  get githubDescription(): string {
    return this.$i18n.locale === "zh"
      ? "浏览实验室在 GitHub 上发布的开源项目、工具与研究代码。"
      : "Explore the lab's open-source projects, tools, and research code.";
  }

  get githubButtonText(): string {
    return this.$i18n.locale === "zh" ? "访问 GitHub" : "Visit GitHub";
  }

  href(code: CodeType): string | undefined {
    if (code.md) return `/code/${code.title}`;
    else if (code.href) return code.href;
  }

  isCompactToolLogo(code: CodeType): boolean {
    return code.title === "THU-DeepHypergraph" || code.title === "THU-HyperG";
  }

  isTinyHyperGLogo(code: CodeType): boolean {
    return code.title === "THU-HyperG";
  }

  get cardHeight(): number {
    if (this.$vuetify.breakpoint.xl) return 450;
    else return 350;
  }
}
